<div class="info">
  Hiển thị kết quả từ
  {{ (page - 1) * size == 0 ? 1 : (page - 1) * size + 1 }}
  - {{ page * size < total ? page * size : total }} trên tổng {{ total }}
</div>
